import vv_utils from "./vv_utils";

/*-----------------------------------------------
|   Application Details
-----------------------------------------------*/

/* eslint-disable max-len*/

const errorDetailsInit_onStart = () => {
  const errorMetaEl = document.getElementById("vvjson");

  let errObj = {};
  let metacode = "";
  if (errorMetaEl && errorMetaEl.dataset && errorMetaEl.dataset.vvjson) {
    try {
      errObj = JSON.parse(atob(errorMetaEl.dataset.vvjson));
      
      metacode = errObj.code;
    }
    catch {
      //do nothing, use the blank default
    }
  }

  const urlparams = new URLSearchParams(window.location.search);
  const querycode = urlparams.get("code");
  let errText = "";

  // favor the metacode
  let code = metacode ? metacode : querycode;
  if (code && vv_utils.messageMap[code]) {
    errText = vv_utils.messageMap[code];
  } else {
    errText = "Our services are currently unavailable.";
  }

  // if the client_id is currently available, pass it along to
  // the login request.
  const loginBtn = document.getElementById("errorLoginButton");
  const loginBtnUrl = new URL(loginBtn.href);
  const clientId = urlparams.get("client_id");
  if (clientId) {
    loginBtnUrl.searchParams.set("client_id", clientId);
  }

  loginBtn.href = loginBtnUrl.toString();

  // plain error container is used by default
  const peCont = document.getElementById("errordisplay");
  if (!errObj.devmode) {
    peCont.innerText = errText;
    return;
  }
  peCont.classList.add("d-none")

  // show the error display text
  const dmText = document.getElementById("devmodeErrorText");
  dmText.innerText = errText;

  // show the error suggestion
  if (metacode === "oidc_redirect_invalid") {
    const p = errObj.params
    if (p && p.redirect_url) {
      document.getElementById("devmodeErrorSpacer")
        .classList.remove('d-none');
      const hdr = document.getElementById("devmodeErrorCurrentHeader")
      hdr.innerText = "Requested Redirect URL:";
      hdr.classList.remove('d-none');

      const val = document.getElementById("devmodeErrorCurrentValue")
      val.innerText = p.redirect_url;
      val.classList.remove('d-none');
    }
    if (p && p.redirect_url_suggestion) {
      document.getElementById("devmodeErrorSpacer")
        .classList.remove('d-none');
      const hdr = document.getElementById("devmodeErrorSuggestedHeader")
      hdr.innerText = "Fix With Redirect URL:";
      hdr.classList.remove('d-none');

      const val = document.getElementById("devmodeErrorSuggestedValue")
      val.innerText = p.redirect_url_suggestion;
      val.classList.remove('d-none');
    }
  }

  // show the error display container
  const dmCont = document.getElementById("devmodeContainer");
  dmCont.classList.remove("d-none");
}


export default { errorDetailsInit_onStart };

